import 'object.fromentries';

export default defineNuxtRouteMiddleware((to, from) => {
  const legacyQuery = Object.entries(from.query).filter(([ k ]) => k.startsWith('c_') || k === 'bd_vid' || k === 'gclid');
  if (legacyQuery.length && !legacyQuery.every(([ k ]) => to.query[k])) {
    to.query = {  ...to.query, ...Object.fromEntries(legacyQuery) };
    return navigateTo(to);
  }
});
